import type { IWorkflowError } from 'utils/errors/workflowErrors';
import { getSummaryFromErrorMessage } from 'utils/errors/workflowErrors';

const maxLengthForPanelTitle = 90;

const formatPanelTitle = (title: string): string => {
  return title.length > maxLengthForPanelTitle ? title.slice(0, maxLengthForPanelTitle).trim() + '...' : title;
};

export const getPanelTitleFromErrorMessage = (errorMessage: IWorkflowError, useErrorCode = false): string => {
  const resumeText = getSummaryFromErrorMessage(errorMessage, useErrorCode);
  return formatPanelTitle(resumeText);
};
